// Must match the model keys the server accepts (server/src/Services/llmModels.ts)
export type LlmModelOption = {
  key: string;
  label: string;
  description: string;
  // Context window in tokens, used by the token limit warning
  maxTokens: number;
};

export const LLM_MODELS: LlmModelOption[] = [
  {
    key: 'GPT_61',
    label: 'GPT 6.1',
    description: 'Newest and most capable model',
    maxTokens: 1050000,
  },
  {
    key: 'GPT_51',
    label: 'GPT 5.1',
    description: 'Previous model',
    maxTokens: 400000,
  },
];

export const DEFAULT_LLM_MODEL = LLM_MODELS[0];

export const findLlmModel = (key: string): LlmModelOption =>
  LLM_MODELS.find((model) => model.key === key) ?? DEFAULT_LLM_MODEL;
